import { Component } from '@angular/core';
import { AppService } from '@app/@core/services/app.service';
import { DataStoreService } from '@app/@core/services/data-store.service';
import { supportIntegrationService } from '@app/@core/services/support-integration.service';
import { environment } from '@env/environment';
import { BehaviorSubject } from 'rxjs';

@Component({
  standalone: false,
  selector: 'app-support-integration',
  templateUrl: './support-integration.component.html',
  styleUrls: ['./support-integration.component.scss']
})
export class SupportIntegrationComponent {
commonService:BehaviorSubject<any>;

constructor(
  private dataStoreService:DataStoreService,
  private supportIntegrationService:supportIntegrationService,
  private appService:AppService
){
  this.commonService = new BehaviorSubject<any>(null);
  this.commonService.next({
    DATASTORESERVICE:this.dataStoreService,
    ENVIRONMENT:environment,
    SUPPORTSERVICE: this.supportIntegrationService,
    APPSERVICE:this.appService
  })
}
}
